export default __webpack_public_path__ + "static/singaporeCrmHeroImg-26d2e50e4f9b372bf0df7c38c42acd3e.webp";